import React, { useEffect } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { resetCreativeState } from "../../../actions/app/creatives"
import { clearLandingPages } from "../../../actions/dcm/landingPages";
import { clearAllChangeLogCache } from "../../../utils/cacheUtils";
import { makeStyles } from "@material-ui/core/styles";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  MenuItem,
  Menu,
  Grid
} from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

import BartLogo from "./Images/BartLogo.png";
import CLogo from "./Images/c-favicon.png";

const useStyles = makeStyles((theme) => ({
  root: {
    // height: "10vh"
  },
  title: {
    paddingLeft: 16,
    paddingBottom: 6
  },
  bartLogo: {
    width: 60
  },
  caratLogo: {
    height: 50
  },
  logoLink: {
    color: "white",
    textDecoration: "none"
  },
  link: {
    color: "#000",
    textDecoration: "none"
  }
}));

const Header = () => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedTask, setSelectedTask] = React.useState("Assign Creatives");

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = (task) => {
    if (task) setSelectedTask(task);
    setAnchorEl(null);
  };

  useEffect(() => {
    switch (history.location.pathname) {
      case "/preloader":
        setSelectedTask("Creative Preloader");
        break;
      case "/name":
        setSelectedTask("Creative Naming");
        break;
      case "/changelog":
        setSelectedTask("Creative Log");
        break;
      default:
        setSelectedTask("Assign Creatives");
    }
  }, [history.location.pathname]);

  const logout = () => {
    dispatch(clearLandingPages());
    dispatch(resetCreativeState());

    localStorage.removeItem("googleAccessToken");
    localStorage.removeItem("googleAccessTokenExpiryDate");
    localStorage.removeItem("googleRefreshToken");
    localStorage.removeItem("googleProfileId");
    clearAllChangeLogCache();

    history.push("/login");
  };

  return (
    location.pathname !== "/login" && (
      <div className={classes.root}>
        <AppBar position="static" color="primary">
          <Toolbar
            style={{
              minHeight: "10vh"
            }}
          >
            <Grid container spacing={3} alignItems="center">
              <Grid item xs={4} style={{ textAlign: "left" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center"
                  }}
                >
                  <Link to="/">
                    <img
                      alt="Bart"
                      src={BartLogo}
                      className={classes.bartLogo}
                    />
                  </Link>
                  <Link to="/" className={classes.logoLink}>
                    <Typography variant="h6" className={classes.title}>
                      Bart
                    </Typography>
                  </Link>
                </div>
              </Grid>
              <Grid item xs={4} style={{ textAlign: "center" }}>
                <a href="https://www.carat.com">
                  <img alt="Carat" src={CLogo} className={classes.caratLogo} />
                </a>
              </Grid>
              <Grid container item xs={4} direction="row" justify="flex-end">
                <>
                  <Button
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={handleClick}
                    color="inherit"
                    disableElevation
                  >
                    {selectedTask}
                    <ArrowDropDownIcon />
                  </Button>
                  <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={() => handleCloseMenu()}
                    transformOrigin={{
                      vertical: -45,
                      horizontal: "left"
                    }}
                  >
                    <MenuItem
                      onClick={() => handleCloseMenu("Assign Creatives")}
                    >
                      <Link to="/" className={classes.link}>
                        Assign Creatives
                      </Link>
                    </MenuItem>
                    <MenuItem
                      onClick={() =>
                        handleCloseMenu("Creative Naming")
                      }
                    >
                      <Link to="/name" className={classes.link}>
                        Creative Naming
                      </Link>
                    </MenuItem>
                    <MenuItem
                      onClick={() => handleCloseMenu("Creative Preloader")}
                    >
                      <Link to="/preloader" className={classes.link}>
                        Creative Preloader
                      </Link>
                    </MenuItem>
                    <MenuItem
                      onClick={() => handleCloseMenu("Creative Log")}
                    >
                      <Link to="/changelog" className={classes.link}>
                        Creative Log
                      </Link>
                    </MenuItem>
                  </Menu>
                  <Button
                    href="/help"
                    disableElevation
                    className={classes.logoLink}
                  >
                    Help
                  </Button>
                  <Button onClick={logout} color="inherit" disableElevation>
                    Log Out
                  </Button>
                </>
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
      </div>
    )
  );
};

export default Header;
